import {
  ICampaign,
  IBuyerIdentity,
  IResponse,
  IBaseGetRequest,
  CryptoCurrenciesE,
  FiatCurrenciesE,
} from 'primsell-shared-layer/types'

export type IGetPurchaseListFilterProperties =
  | 'all'
  | 'buyer'
  | 'buyerIdentity.id'
  | 'campaign.id'
  | 'campaign.name'
  | 'createdAt'
  | 'purchaseType'
  | 'purchaseId'
  | 'nftId'
  | 'campaign.contractAddress'

export type IGetPurchaseListSortProperties =
  | 'amount'
  | 'price'
  | 'priceCrypto'
  | 'royalty'
  | 'royaltyCrypto'
  | 'createdAt'
  | 'campaign.name'
  | 'buyerIdentity.firstName'
  | 'buyerIdentity.email'
  | 'buyerIdentity.wallet'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IGetPurchaseListRequest
  extends IBaseGetRequest<IGetPurchaseListFilterProperties, IGetPurchaseListSortProperties> {}

export enum PurchaseE {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export interface IPurchaseDetails {
  id: string | null
  purchaseId: number | null
  purchaseType: PurchaseE | null
  purchaseDate: string | null
  amount: number | null
  currency: FiatCurrenciesE
  price: string | null
  priceCrypto: string | null
  royalty: string | null
  royaltyCrypto: string | null
  cryptoCurrency?: CryptoCurrenciesE | null
  transactionId: string | null
  transactionLink: string | null
  nftId: string | null
  campaign: Pick<ICampaign, 'id' | 'name' | 'codeType' | 'contractAddress'> | null
  buyerIdentity: IBuyerIdentity | null
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IGetPurchaseListResponse extends IResponse<IPurchaseDetails> {}
